var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, Defaults, P, ViewChild, Utils, PacemEventTarget } from '@pacem/pacem-core';
import { Point } from '@pacem/pacem-foundation';
import { PacemFxElement } from './types';
//namespace Pacem.Components.Fx {
const RIPPLE_CSS = "ripple";
let PacemFxRippleElement = class PacemFxRippleElement extends PacemFxElement {
    constructor() {
        super(...arguments);
        this._lock = false;
        this._remove = false;
        this._rippleHandler = (e) => {
            if (this.disabled || (this.target instanceof PacemEventTarget && this.target.disabled)) {
                return;
            }
            if (e instanceof MouseEvent && e.button !== 0) {
                // only the 'main' (left) button click goes.
                return;
            }
            const rect = Utils.offset(this.target);
            const style = getComputedStyle(this.target);
            const css = this.style;
            css.top = rect.top + 'px';
            css.left = rect.left + 'px';
            css.width = rect.width + 'px';
            css.height = rect.height + 'px';
            css.borderRadius = style.borderRadius;
            const pointSrc = e.type === 'touchstart' ? e.touches[0] : e;
            const point = { x: pointSrc.pageX, y: pointSrc.pageY };
            const topLeft = { x: rect.left, y: rect.top }, topRight = { x: rect.left + rect.width, y: rect.top }, bottomLeft = { x: rect.left, y: rect.top + rect.height }, bottomRight = { x: topRight.x, y: bottomLeft.y };
            const radius = Math.max(Point.distance(point, topLeft), Point.distance(point, topRight), Point.distance(point, bottomRight), Point.distance(point, bottomLeft));
            const wave = this._wave;
            wave.style.left = (point.x - rect.left - radius) + 'px';
            wave.style.top = (point.y - rect.top - radius) + 'px';
            wave.style.width = wave.style.height = (2 * radius) + 'px';
            Utils.addAnimationEndCallback(wave, () => {
                this._lock = false;
                this._tryRemove();
            });
            this._lock = true;
            Utils.addClass(wave, 'ripple-go');
        };
        this._unrippleHandler = (e) => {
            this._remove = true;
            this._tryRemove();
        };
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        // target switch?
        if (name === 'target') {
            if (!Utils.isNull(old)) {
                this._reset(old);
            }
            if (!Utils.isNull(val)) {
                this._set(val);
            }
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        if (!Utils.isNull(this.target))
            this._set();
    }
    disconnectedCallback() {
        if (!Utils.isNull(this.target))
            this._reset();
        super.disconnectedCallback();
    }
    _tryRemove() {
        if (!this._lock && this._remove) {
            this._remove = false;
            Utils.removeClass(this._wave, 'ripple-go');
        }
    }
    _set(val = this.target) {
        val.addEventListener('mousedown', this._rippleHandler, false);
        val.addEventListener('touchstart', this._rippleHandler, false);
        val.addEventListener('touchend', this._unrippleHandler, false);
        val.addEventListener('mouseup', this._unrippleHandler, false);
        val.addEventListener('mousemove', this._unrippleHandler, false);
    }
    _reset(old = this.target) {
        old.removeEventListener('mousedown', this._rippleHandler, false);
        old.removeEventListener('touchstart', this._rippleHandler, false);
        old.removeEventListener('touchend', this._unrippleHandler, false);
        old.removeEventListener('mouseup', this._unrippleHandler, false);
        old.removeEventListener('mousemove', this._unrippleHandler, false);
    }
};
__decorate([
    ViewChild('.' + RIPPLE_CSS)
], PacemFxRippleElement.prototype, "_wave", void 0);
PacemFxRippleElement = __decorate([
    CustomElement({
        tagName: P + '-fx-ripple', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<div class="${RIPPLE_CSS}"></div>`
    })
], PacemFxRippleElement);
export { PacemFxRippleElement };
